import { useEffect } from 'react';

/**
 * Entrada das partes de cada seção: sobem uma vez, quando chegam à tela.
 *
 * Só esconde o que ainda está abaixo da dobra no momento da montagem. O HTML do
 * pré-render, e quem está sem JavaScript ou pediu menos movimento, vê tudo no
 * lugar desde o começo: nada fica invisível esperando uma animação.
 */
const useRevelar = (raiz) => {
  useEffect(() => {
    const el = raiz.current;
    if (!el || !('IntersectionObserver' in window)) return undefined;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;

    const alvos = [...el.querySelectorAll('[data-r]')].filter(
      (alvo) => alvo.getBoundingClientRect().top > window.innerHeight
    );
    alvos.forEach((alvo) => alvo.classList.add('nh-espera'));

    const observador = new IntersectionObserver(
      (itens) => {
        for (const item of itens) {
          if (!item.isIntersecting) continue;
          item.target.classList.remove('nh-espera');
          observador.unobserve(item.target);
        }
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    alvos.forEach((alvo) => observador.observe(alvo));
    return () => observador.disconnect();
  }, [raiz]);
};

export default useRevelar;
